// extracted by css-extract-rspack-plugin
export default {"cls1":"Banner-cls1_Iz0","cls2":"Banner-cls2_IdB Banner-cls1_Iz0"};